import React, { useState, useMemo } from 'react';
import { MapPin, Calendar, Phone, Globe, ChevronLeft, ChevronRight, Briefcase, UserCircle } from 'lucide-react';
import countryList from 'react-select-country-list';
import { FieldError, FieldWrap, cls, getErr } from './helpers';

const StepProfil = ({ data, onChange, onNext, onBack }) => {
    const [errors, setErrors] = useState({});
    const countryOptions = useMemo(() => countryList().getData(), []);

    const validate = () => {
        const e = {};
        if (!data.genre)                  e.genre          = "La civilité est requise";
        if (!data.date_naissance)         e.date_naissance = "La date de naissance est requise";
        if (!data.lieu_naissance?.trim()) e.lieu_naissance = "Le lieu de naissance est requis";
        if (!data.nationalite)            e.nationalite    = "La nationalité est requise";
        if (!data.adresse?.trim())        e.adresse        = "L'adresse est requise";
        setErrors(e);
        return Object.keys(e).length === 0;
    };

    const set = (field) => (e) => onChange({ ...data, [field]: e.target.value });

    return (
        <div className="space-y-3">
            <div className="grid grid-cols-2 gap-3">
                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">Civilité <span className="text-red-500">*</span></label>
                    <select value={data.genre} onChange={set('genre')} className={cls(errors.genre, false)}>
                        <option value="">Sélectionnez</option>
                        <option value="monsieur">Monsieur</option>
                        <option value="madame">Madame</option>
                        <option value="mademoiselle">Mademoiselle</option>
                    </select>
                    <FieldError msg={getErr(errors, 'genre')} />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">Situation familiale</label>
                    <select value={data.situation_familiale} onChange={set('situation_familiale')} className={cls(false, false)}>
                        <option value="">Sélectionnez</option>
                        <option value="celibataire">Célibataire</option>
                        <option value="marié">Marié(e)</option>
                        <option value="divorcé">Divorcé(e)</option>
                        <option value="veuf">Veuf/Veuve</option>
                    </select>
                </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">Date de naissance <span className="text-red-500">*</span></label>
                    <FieldWrap icon={Calendar}><input type="date" value={data.date_naissance} onChange={set('date_naissance')} className={cls(errors.date_naissance)} /></FieldWrap>
                    <FieldError msg={getErr(errors, 'date_naissance')} />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">Lieu de naissance <span className="text-red-500">*</span></label>
                    <FieldWrap icon={MapPin}><input type="text" value={data.lieu_naissance} onChange={set('lieu_naissance')} className={cls(errors.lieu_naissance)} placeholder="Ville" /></FieldWrap>
                    <FieldError msg={getErr(errors, 'lieu_naissance')} />
                </div>
            </div>
            <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Nationalité <span className="text-red-500">*</span></label>
                <select value={data.nationalite} onChange={set('nationalite')} className={cls(errors.nationalite, false)}>
                    {countryOptions.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
                </select>
                <FieldError msg={getErr(errors, 'nationalite')} />
            </div>
            <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Adresse <span className="text-red-500">*</span></label>
                <FieldWrap icon={MapPin}><input type="text" value={data.adresse} onChange={set('adresse')} className={cls(errors.adresse)} placeholder="Adresse complète" /></FieldWrap>
                <FieldError msg={getErr(errors, 'adresse')} />
            </div>
            <div className="grid grid-cols-2 gap-3">
                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">Tél. secondaire</label>
                    <FieldWrap icon={Phone}><input type="tel" value={data.telephone2} onChange={set('telephone2')} className={cls(false)} placeholder="Optionnel" /></FieldWrap>
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">LinkedIn</label>
                    <FieldWrap icon={Globe}><input type="url" value={data.lien_linkdin} onChange={set('lien_linkdin')} className={cls(false)} placeholder="https://linkedin.com/in/..." /></FieldWrap>
                </div>
            </div>
            <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Titre professionnel</label>
                <FieldWrap icon={Briefcase}><input type="text" value={data.titre} onChange={set('titre')} className={cls(false)} placeholder="Ex: Développeur Web, Chef de projet..." /></FieldWrap>
            </div>
            <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">À propos de moi</label>
                <textarea 
                    value={data.apropos} 
                    onChange={set('apropos')} 
                    className={cls(false)} 
                    placeholder="Décrivez brièvement votre parcours et vos objectifs..."
                    rows="3"
                />
            </div>
            <div className="flex gap-2 pt-1">
                <button onClick={onBack} className="flex items-center gap-1 px-4 py-2.5 border border-gray-300 text-gray-600 rounded-lg text-sm hover:bg-gray-50 transition">
                    <ChevronLeft className="h-4 w-4" /> Retour
                </button>
                <button onClick={() => { if (validate()) onNext(); }} className="flex-1 flex justify-center items-center gap-2 py-2.5 bg-orange-600 hover:bg-orange-700 text-white rounded-lg text-sm font-medium transition">
                    Continuer <ChevronRight className="h-4 w-4" />
                </button>
            </div>
        </div>
    );
};

export default StepProfil;
